//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.GeneralArrangement.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/Annotations.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"Color",1,0],[0,"HorizontalFlip",1,0],[1,"Origin",0,"Annotations.OriginBuilder",0],[0,"Pattern",1,0],[1,"Scale",0,"Expression",0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"VerticalFlip",1,0]],[[[],"ClearExpressionsData",{},0,0],[["strTitle","strFormular"],"AddExpressionData",{},2,0]],[]];
SPLM.Features.ShipDesign.GeneralArrangement.EvacuationPlanBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.GeneralArrangement.EvacuationPlanBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;